import gql from 'graphql-tag';

export default gql`
  mutation cartPutInvoiceNote($input: InvoiceNoteInput!) {
    cartPutInvoiceNote(input: $input) {
      success
      userErrors {
        field
        message
      }
    }
  }
`;
